import React from 'react'
import styled from 'styled-components'

export const BodyWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;
  min-height: 600px;
  background: ${({ theme }) => theme.bg1};
  box-shadow: ${({ theme }) => theme.shadow1};
  border-radius: ${({ theme }) => theme.borderRadius.xxl};
  border: 1px solid ${({ theme }) => theme.bg3};
  backdrop-filter: blur(20px);
  transition: all ${({ theme }) => theme.transitions.normal};
  padding: ${({ theme }) => theme.spacing.none};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 100%;
    border-radius: ${({ theme }) => theme.borderRadius.xlarge};
    min-height: 500px;
    margin: 0 ${({ theme }) => theme.spacing.md};
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 0 ${({ theme }) => theme.spacing.sm};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  `};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow2};
    transform: translateY(-2px);
  }

  &:focus-within {
    box-shadow: ${({ theme }) => theme.shadow2}, 0 0 0 3px ${({ theme }) => theme.primary4};
  }
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children }: { children: React.ReactNode }) {
  return <BodyWrapper>{children}</BodyWrapper>
}
